const logLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

let logLevel = 'ERROR';

export function setLogLevel(l) {
  logLevel = l;
}

export class Logger {
  constructor(prefix) {
    this.prefix = prefix;
  }

  print(msg, level) {
    const msgOut = `${this.prefix} [${level}]: ${msg}`;
    let fct = console.log;
    if (level === 'WARN') fct = console.warn;
    if (level === 'ERROR') fct = console.error;
    if (logLevels[level] >= logLevels[logLevel]) fct(msgOut);
  }

  debug(msg) { return this.print(msg, 'DEBUG'); }
  info(msg) { return this.print(msg, 'INFO'); }
  warn(msg) { return this.print(msg, 'WARN'); }
  error(msg) { return this.print(msg, 'ERROR'); }
}
